<template>
  <el-config-provider :size="size" :z-index="zIndex">
    <Default />
    <OverlayLoading v-if="mutationLoading" />
    <transition>
      <Feedback
        v-if="feedback"
        :type="feedback.type"
        :heading="feedback.heading"
        :supplement="feedback.supplement"
      />
    </transition>
  </el-config-provider>
</template>

<script lang="ts" setup>
import Default from '@/layouts/default.vue';
import OverlayLoading from '@/components/organisms/OverlayLoading.vue';
import { ElConfigProvider } from 'element-plus';
import { createOverlayLoading } from '@/composables/useOverlayLoading';
import { createFeedback } from '@/composables/useFeedback';
import Feedback from '@/components/molecules/Feedback.vue';

const mutationLoading = createOverlayLoading();

const { props: feedback } = createFeedback();

const zIndex = 3000;
const size = 'large';
</script>
<style>
body {
  margin: 0;
}
</style>
